/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneDirektTeaser as ResolvedStandaloneDirektTeaser } from 'base/components/standalone/DirektTeaser';

export const DirektTeaser: typeof ResolvedStandaloneDirektTeaser = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneDirektTeaser {...props} />
        </ErrorBoundary>
    );
});

export type DirektTeaserProps = PropsFromComponent<typeof DirektTeaser>;

/** @deprecated Use slot architecture instead */
export const DirektTeaserWith = (extras: DynamicStandaloneExtras): typeof DirektTeaser => {
    return function DirektTeaser(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'DirektTeaser');
        return <ResolvedStandaloneDirektTeaser {...mergeProps({ options: { theme } }, props)} />;
    }
}